import { render, staticRenderFns } from "./StockTransfer.vue?vue&type=template&id=f0ac158e&scoped=true&"
import script from "./StockTransfer.vue?vue&type=script&lang=js&"
export * from "./StockTransfer.vue?vue&type=script&lang=js&"
import style0 from "./StockTransfer.vue?vue&type=style&index=0&id=f0ac158e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ac158e",
  null
  
)

export default component.exports